import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { 
    platform: String, 
    event: String, 
    channel: String, 
    level: String, 
    url: String 
  }

  connect() {
    console.log(`Webhook event toggle controller connected for ${this.platformValue}.${this.eventValue}.${this.channelValue}`)
  }

  async toggle() {
    const enabled = this.element.checked
    const platform = this.platformValue
    const event = this.eventValue
    const channel = this.channelValue
    const level = this.levelValue

    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({
          webhook_event_preference: {
            platform: platform,
            event: event,
            channel: channel,
            enabled: enabled,
            level: level
          }
        })
      })

      if (response.ok) {
        const data = await response.json()
        console.log(`✅ ${platform}.${event}.${channel} ${enabled ? "enabled" : "disabled"}`)
        
        // Show success message
        this.showStatus(data.message || `${event} ${enabled ? "enabled" : "disabled"}`, "success")
      } else {
        const error = await response.json()
        console.error(`❌ Failed to update ${platform}.${event}.${channel}:`, error)
        
        // Revert the toggle
        this.element.checked = !enabled
        
        // Show error message
        this.showStatus(error.message || "Failed to update preference", "error")
      }
    } catch (error) {
      console.error("Error updating webhook event preference:", error)
      
      // Revert the toggle
      this.element.checked = !enabled
      
      // Show error message
      this.showStatus("Failed to update preference", "error")
    }
  }

  showStatus(message, type) {
    // Create a temporary status element
    const statusElement = document.createElement("div")
    statusElement.className = `fixed top-4 right-4 px-4 py-2 rounded-md text-sm font-medium z-50 ${
      type === "success" 
        ? "bg-green-100 text-green-800 border border-green-200" 
        : "bg-red-100 text-red-800 border border-red-200"
    }`
    statusElement.textContent = message
    
    document.body.appendChild(statusElement)
    
    // Remove after 3 seconds
    setTimeout(() => {
      if (statusElement.parentNode) {
        statusElement.parentNode.removeChild(statusElement)
      }
    }, 3000)
  }
}
